/**
 * Shared description-quality scorer used by AnalyzeTab and SourcingTab.
 * Extracted from the original Dashboard.jsx during the tab split (Batch 2 Sub-batch B Step 1).
 * Preserves original scoring semantics.
 */
export const getDescriptionQuality = (desc) => {
  if (!desc || desc.trim().length === 0) return { level: 'empty', color: 'slate', message: '' };

  const words = desc.trim().split(/\s+/).length;
  const hasNumbers = /\d/.test(desc);
  const hasMaterials = /(steel|plastic|metal|wood|glass|rubber|cotton|leather|aluminum|silicon|ceramic|fabric|polymer|alloy)/i.test(desc);
  const hasDimensions = /(inch|cm|mm|kg|lb|oz|gram|meter|foot|feet)/i.test(desc);

  let score = 0;
  if (words >= 5) score += 1;
  if (words >= 10) score += 1;
  if (words >= 15) score += 1;
  if (hasNumbers) score += 1;
  if (hasMaterials) score += 1;
  if (hasDimensions) score += 1;

  if (score >= 4) return { level: 'good', color: 'green', message: 'Detailed description - ready for accurate classification' };
  if (score >= 2) return { level: 'fair', color: 'amber', message: 'Add materials, dimensions, or technical specs for better accuracy' };
  return { level: 'poor', color: 'red', message: 'Too brief - add more details for accurate classification' };
};

/**
 * Shared list of import/origin countries used by AnalyzeTab, SourcingTab, and OriginTab.
 * "United States" is first so it defaults nicely in <Select> UIs.
 * Hoisted from the 3 tab files (Batch 2 Sub-batch B Part 2 bugfix — countries de-dupe).
 */
export const COUNTRIES = [
    "United States", // USA first as default
    "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan",
    "Bahrain", "Bangladesh", "Belarus", "Belgium", "Belize", "Benin", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria", "Burkina Faso",
    "Cambodia", "Cameroon", "Canada", "Chile", "China", "Colombia", "Costa Rica", "Croatia", "Cuba", "Cyprus", "Czech Republic",
    "Denmark", "Dominican Republic",
    "Ecuador", "Egypt", "El Salvador", "Estonia", "Ethiopia",
    "Finland", "France",
    "Georgia", "Germany", "Ghana", "Greece", "Guatemala",
    "Haiti", "Honduras", "Hong Kong", "Hungary",
    "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy",
    "Jamaica", "Japan", "Jordan",
    "Kazakhstan", "Kenya", "Kuwait", "Kyrgyzstan",
    "Laos", "Latvia", "Lebanon", "Libya", "Lithuania", "Luxembourg",
    "Macau", "Madagascar", "Malaysia", "Maldives", "Mali", "Malta", "Mauritius", "Mexico", "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco", "Mozambique", "Myanmar",
    "Nepal", "Netherlands", "New Zealand", "Nicaragua", "Nigeria", "North Korea", "North Macedonia", "Norway",
    "Oman",
    "Pakistan", "Panama", "Paraguay", "Peru", "Philippines", "Poland", "Portugal",
    "Qatar",
    "Romania", "Russia", "Rwanda",
    "Saudi Arabia", "Senegal", "Serbia", "Singapore", "Slovakia", "Slovenia", "Somalia", "South Africa", "South Korea", "Spain", "Sri Lanka", "Sudan", "Sweden", "Switzerland", "Syria",
    "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Tunisia", "Turkey", "Turkmenistan",
    "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "Uruguay", "Uzbekistan",
    "Venezuela", "Vietnam",
    "Yemen",
    "Zambia", "Zimbabwe"
];
